import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { FC } from 'react'
import { useAppSelector } from 'store/hooks'
import { ProductParamsIcon } from 'widget/ProductParamsIcon/ProductParamsIcon'

import { ImageItem } from './ImageItem/ImageItem'
import style from './OrderStepConfirmProductParam.module.scss'

interface IOrderStepConfirmProductParam {
  param: orderFormSpace.Parameter
}

// шаг 6
// ввод личных данных
// -> выводим параметры
export const OrderStepConfirmProductParam: FC<
  IOrderStepConfirmProductParam
> = ({ param }) => {
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const images = useAppSelector(
    state => state.orderForm.forms[currentEditForm].images,
  )
  const fileList = images.filter(cur => cur.paramId === param.id)

  switch (param.type) {
    case 'IMAGES':
      return (
        <div className={style.settings}>
          <div className={style.imgSettings}>
            <span className='default-text'>
              {`${param.name}: `}
              {!fileList.length && 'не указано'}
            </span>
            {!!fileList?.length && (
              <div className={style.fileList}>
                {fileList.map(item => (
                  <ImageItem item={item} key={item.id} />
                ))}
              </div>
            )}
          </div>
        </div>
      )
    case 'CHECKBOX':
      return (
        <div className={style.settings}>
          {param.iconUrl && (
            <ProductParamsIcon url={param.iconUrl} name={param.name} />
          )}
          <span className='default-text'>
            {`${param.name}: `}
            {param.value ? 'да' : 'нет'}
          </span>
        </div>
      )
    case 'DROPDOWN':
    case 'TEXT':
      return (
        <div className={style.settings}>
          {param.iconUrl && (
            <ProductParamsIcon url={param.iconUrl} name={param.name} />
          )}
          <span className='default-text'>
            {`${param.name}: `}
            {param.value ? param.value : 'не указано'}
          </span>
        </div>
      )
    case 'NUMBER':
      return (
        <div className={style.settings}>
          {param.iconUrl && (
            <ProductParamsIcon url={param.iconUrl} name={param.name} />
          )}
          <span className='default-text'>
            {`${param.name}: `}
            {param.value ? +param.value : 'не указано'}
          </span>
        </div>
      )
    default:
      return <>unknown params</>
  }
}
